module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7r6n5r1n-c1bd2785aa59cc0abd32f444f1571544.svg";